import { render } from "./lrbYTable3.vue?vue&type=template&id=b295d7a2&scoped=true"
import script from "./lrbYTable3.vue?vue&type=script&lang=js"
export * from "./lrbYTable3.vue?vue&type=script&lang=js"

import "./lrbYTable3.vue?vue&type=style&index=0&id=b295d7a2&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b295d7a2"]])

export default __exports__